import { render } from "./Reading.vue?vue&type=template&id=1cc64a64&scoped=true"
import script from "./Reading.vue?vue&type=script&lang=js"
export * from "./Reading.vue?vue&type=script&lang=js"

import "./Reading.vue?vue&type=style&index=0&id=1cc64a64&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc64a64"]])

export default __exports__